import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function Privacy() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-warm-sand">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 sm:py-16">
        <Button variant="ghost" onClick={() => navigate(-1)} className="mb-6 text-[#005F73]" data-testid="btn-back">
          <ArrowLeft className="w-4 h-4 mr-2" /> Retour
        </Button>

        <h1 className="text-3xl sm:text-4xl font-semibold text-[#005F73] mb-8">Politique de confidentialité</h1>

        <div className="space-y-8 text-stone-700 leading-relaxed text-sm sm:text-base">
          <section>
            <h2 className="text-lg font-semibold text-[#005F73] mb-3">1. Responsable du traitement</h2>
            <p>
              Le responsable du traitement des données personnelles est GwadImmo Invest, joignable à l'adresse : <a href="mailto:gwadimmo.invest@gmail.com" className="text-[#0A9396] underline">gwadimmo.invest@gmail.com</a>.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#005F73] mb-3">2. Données collectées</h2>
            <p>Dans le cadre de l'utilisation du service, nous collectons les données suivantes :</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li><strong>Données d'inscription</strong> : nom complet, adresse email</li>
              <li><strong>Données de projet</strong> : informations relatives aux simulations immobilières (prix, loyers, charges, etc.)</li>
              <li><strong>Données de paiement</strong> : traitées exclusivement par Stripe, notre prestataire de paiement sécurisé. Aucune donnée bancaire n'est stockée sur nos serveurs.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#005F73] mb-3">3. Finalités du traitement</h2>
            <p>Vos données sont utilisées pour :</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Créer et gérer votre compte utilisateur</li>
              <li>Fournir le service de calcul de rentabilité immobilière</li>
              <li>Gérer les abonnements et paiements</li>
              <li>Envoyer des emails transactionnels (bienvenue, réinitialisation de mot de passe, confirmation de paiement)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#005F73] mb-3">4. Base légale</h2>
            <p>
              Le traitement de vos données repose sur l'exécution du contrat (fourniture du service) et votre consentement lors de l'inscription.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#005F73] mb-3">5. Durée de conservation</h2>
            <p>
              Vos données personnelles sont conservées pendant toute la durée de votre inscription au service. En cas de suppression de compte, vos données seront effacées dans un délai de 30 jours, à l'exception des données nécessaires au respect de nos obligations légales (facturation).
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#005F73] mb-3">6. Partage des données</h2>
            <p>Vos données personnelles ne sont jamais vendues. Elles peuvent être partagées uniquement avec :</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li><strong>Stripe</strong> : pour le traitement sécurisé des paiements</li>
              <li><strong>Notre hébergeur</strong> : pour le stockage sécurisé des données</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#005F73] mb-3">7. Sécurité</h2>
            <p>
              Nous mettons en place des mesures techniques et organisationnelles pour protéger vos données : chiffrement des mots de passe, connexions sécurisées (HTTPS), accès restreint aux données.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#005F73] mb-3">8. Vos droits (RGPD)</h2>
            <p>Conformément au RGPD, vous disposez des droits suivants :</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li><strong>Droit d'accès</strong> : obtenir une copie de vos données</li>
              <li><strong>Droit de rectification</strong> : corriger vos données inexactes</li>
              <li><strong>Droit de suppression</strong> : demander l'effacement de vos données</li>
              <li><strong>Droit à la portabilité</strong> : recevoir vos données dans un format structuré</li>
              <li><strong>Droit d'opposition</strong> : vous opposer au traitement de vos données</li>
            </ul>
            <p className="mt-2">
              Pour exercer vos droits, contactez-nous à : <a href="mailto:gwadimmo.invest@gmail.com" className="text-[#0A9396] underline">gwadimmo.invest@gmail.com</a>.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#005F73] mb-3">9. Cookies</h2>
            <p>
              Le site utilise uniquement des cookies techniques nécessaires au fonctionnement du service (token d'authentification stocké en localStorage). Aucun cookie publicitaire, analytique ou de suivi tiers n'est utilisé.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#005F73] mb-3">10. Modification de la politique</h2>
            <p>
              Cette politique de confidentialité peut être mise à jour. Toute modification sera communiquée par email aux utilisateurs inscrits. Date de dernière mise à jour : mars 2026.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
